import type { ChildDom } from "vanjs-core";
import { modal } from "..";
import type { PriceWrapper } from "../billing/prices";
import type { Device, DeviceIdType, DeviceType } from "../device/device";
import { t } from "../locale";
import type { RouteContext } from "../router";
import { centeredBox } from "./centered-box";
import { deviceNameField } from "./device-name-field";
import { deviceOwnerField } from "./device-owner-field";
import { deviceSharingField } from "./device-sharing-field";
import { subscriptionField } from "./device-subscription-field";
import { deviceTagsField } from "./device-tags-field";
import { button, div, h1, h2, hr, p } from "./van-tags";

interface Params {
	ctx: RouteContext;
	device: Device;
	deviceIdType: DeviceIdType;
	deviceType: DeviceType;
	fields: ChildDom[];
	isOwner: boolean;
	prices: [string, PriceWrapper][];
	save: () => Promise<void>;
	unregister: () => Promise<void>;
}

interface Shared {
	device: Device;
	deviceId: string;
	isOwner: boolean;
	prices: [string, PriceWrapper][];
}

export const deviceSettingsBox = (args: Params, shared: Shared): ChildDom => {
	return centeredBox(
		{ size: "narrow" },
		h1({ class: "title is-4" }, args.deviceType),
		h2(
			{ class: "subtitle is-6" },
			() => `${args.deviceIdType} ${shared.deviceId}`,
		),
		deviceNameField(shared),
		deviceOwnerField(shared),
		deviceSharingField(shared),
		deviceTagsField(shared),
		subscriptionField(shared),
		hr(),
		...args.fields,
		hr(),
		div(
			{ class: "buttons" },
			button(
				{ class: "button is-primary", onclick: () => args.save() },
				() => t.save,
			),
			button(
				{
					class: "button is-primary",
					onclick: () =>
						args.ctx.router.jump(`/devices?id=${shared.deviceId}`),
				},
				() => t.back,
			),
			button(
				{
					class: "button is-danger",
					onclick: () => {
						modal.open({
							header: t.device.settingsPage.removeDeviceLabel,
							body: [
								p(
									() =>
										t.device.settingsPage
											.deviceRemovalDisclaimer,
								),
							],
							footer: [
								button(
									{
										class: "button is-danger",
										onclick: () => {
											args.unregister().finally(
												modal.close,
											);
										},
									},
									() => t.confirm,
								),
								button(
									{
										class: "button",
										onclick: () => modal.close(),
									},
									() => t.cancel,
								),
							],
						});
					},
				},
				() => t.remove,
			),
		),
	);
};
